export function capitalizeFirstLetter(string?: string) {
  if (!string) return string;
  // Insert a space before each uppercase letter
  const spacedString = string.replace(/([A-Z])/g, " $1");
  // Capitalize the first letter of each word
  return spacedString.replace(/\b\w/g, (char) => char.toUpperCase());
}
